import request from "../utils/request";

export function getHistory(params, signal) {
  return request({
    url: "/order/list",
    method: "get",
    data: params,
    signal,
  });
}

export function getAnalytics(params, signal) {
  return request({
    url: "/analytic",
    method: "get",
    data: params,
    signal,
  });
}

export function getCsvExport(params) {
  return request({
    url: "/order/csv",
    method: "get",
    data: params,
    responseType: "arraybuffer",
  });
}
